import React, { useMemo } from 'react';
import { PreFormattedList } from './generic/PreFormattedList';
import { ParseListsFromTextFile } from '../utils/file-parsers';
import { useGetGreatestListRaw } from '../utils/file-reader';
import { useParams } from 'react-router';
import { Typography } from '@mui/material';

// Map route param to section header in GreatestLists.txt
const sectionHeaders: Record<string, string> = {
  Music: 'Best Game Music',
  Songs: 'Best Game Songs',
  MomentOrSequence: 'Best Moment Or Sequence',
  Series: 'Best Series',
  Zelda: 'Zelda',
  Metroidvania: 'Metroidvania',
  GamesIDidntFinish: "Games I didn't finish",
  Top5Songs: 'Top 5 songs of all time',
};

function findSection(lists: string[], section: string): string | null {
  for (let i = 0; i < lists.length; i++) {
    if (lists[i].trim().startsWith(section)) {
      return lists[i];
    }
  }
  return null;
}

export const OtherList = () => {
  const { listType } = useParams();
  const rawLists = useGetGreatestListRaw();
  const parsedLists = useMemo(() => ParseListsFromTextFile(rawLists), [rawLists]);
  const sectionHeader = sectionHeaders[listType ?? ''] ?? '';
  const sectionData = useMemo(() => findSection(parsedLists, sectionHeader), [parsedLists, sectionHeader]);

  if (!sectionData) {
    return <Typography variant="body2">List not found.</Typography>;
  }

  // Special logic for Top 5 Songs
  if (listType === 'Top5Songs') {
    // The sectionData is a single string with all lines concatenated
    const lines = sectionData.split(/\r?\n|\n|\r/).map(line => line.trim()).filter(line => line !== '');
    // Find header and separator
    const headerString = lines[0];
    let startIdx = 1;
    while (startIdx < lines.length && !/^[-]{2,}/.test(lines[startIdx])) startIdx++;
    startIdx++;
    const items = lines.slice(startIdx);
    return (
      <div>
        <h2>{headerString}</h2>
        <div>
          {items.map((item, index) => (
            <div className="list-item" key={index}>
              <span className="list-number">{index < 5 ? index + 1 : 5}.</span>
              <span className="list-content">{item}</span>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return <PreFormattedList data={sectionData} />;
};
